import { Utils } from 'src/app/common/services/utils.service';
import { AppConfigService } from './app-config.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, catchError, takeUntil, tap, timeout, switchMap, take } from 'rxjs/operators';
import { defer, forkJoin, fromEvent, Observable, ReplaySubject, Subject, throwError } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/auth/auth.service';
import { ConfirmationService } from 'primeng/api';
import { __assign } from 'tslib';


@Injectable()
export class HttpRequestService {

  baseUrl = this.appConfig.appBaseUrl['baseUrl'] + '/JMSServlet';
  ivmsBaseUrl = this.appConfig.appBaseUrl['baseUrl'] + '/JMSRestInitService';
  calendarBaseUrl = this.appConfig.appBaseUrl['calendarBaseUrl'];
  // subscribed$: Subject<void> = new Subject<void>();
  apiHits = [];
  timeout: any;
  apiCount = 0;
  footerSection: Subject<void> = new Subject<void>();

  constructor(private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: Utils,
    private ngxService: NgxUiLoaderService,
    private authService: AuthService,
    private confirmationService: ConfirmationService) { }

  setFoorterSection(footerTemplate) {
    this.footerSection.next(footerTemplate);
  }

  // postT(requestParam: any, headers: any, message: string, url?: string) {
  //   const baseUrl = url ? url : this.baseUrl;
  //   this.apiCount++;
  //   return this.http.post(baseUrl, requestParam, { 'headers': headers }).pipe(takeUntil(this.subscribed$),
  //     map((data: any) => {
  //       const resK = Object.keys(data);
  //       this.apiCount--;
  //       this.subscribed$.complete();
  //       if ((!resK && !resK.length) || !!data.strFailureMsg || !!data.strSuccessMsg) {
  //         const confirmConfig: any = {
  //           message: (!resK && !resK.length) ? 'Seems your session might be ended. Please relogin' :
  //             (data.strFailureMsg ? data.strFailureMsg : (message ? message : data.strSuccessMsg)),
  //           header: data.strFailureMsg ? 'Failure' : 'Success',
  //           icon: data.strFailureMsg ? 'pi pi-exclamation-triangle' : 'pi pi-exclamation-triangle',
  //           acceptLabel: 'OK',
  //           rejectVisible: false
  //         };

  //         if (!resK && !Object.keys(resK).length) {
  //           confirmConfig.accept = () => {
  //             this.authService.logout();
  //           };
  //         }
  //         this.confirmationService.confirm(confirmConfig);
  //       }

  //       if (this.apiCount === 0) {
  //         this.ngxService.stop();
  //       }

  //       if (data.strFailureMsg) {
  //         new Error(data.strFailureMsg);
  //         return;
  //       }

  //       return {
  //         'grid_array': data.grid_array,
  //         'combo_array': data.combo_array,
  //         'hdrcache': data.hdrcache ? data.hdrcache[0] : null
  //       };
  //     }), catchError(errormsg => {
  //       this.subscribed$.complete();
  //       this.confirmationService.confirm({
  //         message: errormsg,
  //         header: 'Error',
  //         icon: 'fa fa-check-circle',
  //         acceptLabel: 'OK',
  //         rejectVisible: false,
  //       });
  //       return throwError(errormsg);
  //     }));
  // }

  post(requestParam: any, headers: any, message: string, url?: string): Observable<any> {
    const baseUrl = url ? url : this.baseUrl;
    const apiCall = this.http.post(baseUrl, requestParam, { 'headers': headers, withCredentials: true });
    this.apiCount++;
    return apiCall.pipe(timeout(420000), map((res) => {
      const resK = Object.keys(res);
      this.apiCount--;
      if (!this.apiCount) {
        this.ngxService.stop();
      }
      if (!resK && !resK.length) {
        this.confirmationService.confirm({
          message: message,
          header: 'Success',
          icon: 'fa fa-check-circle',
          acceptLabel: 'OK',
          rejectVisible: false,
          accept: () => {
            this.authService.logout();
          }
        });
        return;
      };
      if (res['strFailureMsg']) {
        this.confirmationService.confirm({
          message: res['strFailureMsg'],
          header: 'Alert !',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'OK',
          rejectVisible: false,
        });
        const msg = {
          isFromSuccess: true,
          failureMsg: res['strFailureMsg']
        }
        // throw new Error(res['strFailureMsg']);
      } else if (res['strSuccessMsg']) {
        this.confirmationService.confirm({
          message: res['strSuccessMsg'],
          header: 'Success',
          icon: 'fa fa-check-circle',
          acceptLabel: 'OK',
          rejectVisible: false,
        });
        return res;
      } else {
        if (message) {
          this.confirmationService.confirm({
            message: message,
            header: 'Success',
            icon: 'fa fa-check-circle',
            acceptLabel: 'OK',
            rejectVisible: false,
          });
        }
        return res;
      }
    },
      (err) => {
        console.log(err);
        this.confirmationService.confirm({
          message: err,
          header: 'Error',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'OK',
          rejectVisible: false,
        });
        this.ngxService.stop();
        return err;
      }
    ),
      catchError(err => {
        console.log(err);
        if (!err.message) {
          this.confirmationService.confirm({
            message: 'Your session migt be ended. So, Please logout and login again.',
            header: 'Alert !',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'OK',
            rejectVisible: false,
          });
        }
        this.ngxService.stop();
        return throwError(err);
      }));
  }

  configRequestDataWithHeaders(params, method, message, hideProgress?: boolean, url?: string) {
    // this.authService.resetTimer();
    if (!window.navigator.onLine) {
      this.confirmationService.confirm({
        message: 'Please check your internet connection',
        header: 'Error',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'OK',
        rejectVisible: false,
      });
      return;
    }
    if (!hideProgress) {
      this.ngxService.start();
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Accept', '*/*')
      .set('X-Requested-With', 'XMLHttpRequest');

    let httpParms: HttpParams = new HttpParams();
    for (const param in params) {
      if (param && params.hasOwnProperty(param)) {
        httpParms = httpParms.set(param, params[param]);
      }
    }
    const baseUrl = url ? url : this.baseUrl;
    return this[method](httpParms, headers, message, baseUrl);
  }

  getImage(url) {
    return this.http.get(url);
  }

  fileUpload(file: File): Observable<any>  {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    let uploadResponse: ReplaySubject<any> = new ReplaySubject(1);
    reader.onload = ((a) => {
      try {
        if (reader.result) {
          const base64Data = reader.result as string;
          const base64String = base64Data.split(',')[1];
          const fileContentType = base64Data.split(',')[0].split(';')[0].split(':')[1];
          const fileExtension = file.name.substring(file.name.lastIndexOf('.'))
          const request = {
            "arrList": [
              {
                // "fileName_id": uuidv4(),
                "fileName": file.name,
                "extension": fileExtension,
                "fileContent": base64String
              }
            ]
          };
          const url = this.appConfig.appBaseUrl['baseUrl'] + '/UploadFileServlet';

          let headers = new HttpHeaders();
          headers = headers.set('Content-Type', 'application/json');
          this.http.post(url, request, { 'headers': headers }).subscribe({
            next: (response: any) => {
              if(response.fileIds && response.fileIds.length > 0){
                uploadResponse.next({
                  "body": {
                    "fileName": response.fileIds[0],
                    "Success": response.returnMessage
                  }
                }); 
              }else{
                uploadResponse.next({
                  "body": {
                    "Failure": response.returnMessage
                  }
                }); 
              }
            },
            error: (err: any) => {
              // If the HTTP call errors, push the error into the subject stream
              uploadResponse.error(err); 
            },
            complete: () => {
              // Once the HTTP call completes, complete the subject.
              // This is what makes forkJoin proceed.
              uploadResponse.complete();
            }
          })
          
          // const requestData = this.utils.constructRequestData(extendedData, 'fileQuery2', '');
          
          // this.configRequestDataWithHeaders(requestData, 'post', '')
          // // this.configRequestDataWithHeaders(requestData, 'post', '')
          //   .subscribe({
          //     next: (response: any) => {
          //       if(response.finalArray && response.finalArray.length > 0){
          //         uploadResponse.next({
          //           "body": {
          //             "fileName": response.finalArray[0],
          //             "Success": "File Uploaded Successfully"
          //           }
          //         }); 
          //       }else{
          //         uploadResponse.next({
          //           "body": {
          //             "Failure": "Failed to Uploade"
          //           }
          //         }); 
          //       }
          //     },
          //     error: (err: any) => {
          //       // If the HTTP call errors, push the error into the subject stream
          //       uploadResponse.error(err); 
          //     },
          //     complete: () => {
          //       // Once the HTTP call completes, complete the subject.
          //       // This is what makes forkJoin proceed.
          //       uploadResponse.complete();
          //     }
          //   })

          //   const a:any = {};
          // a[file.name] = base64String
          // const requst = {
          //   inputType: "imageUpload",
          //   mobileImagesHMVar: a
          // }
          // const url = this.appConfig.appBaseUrl['baseUrl'] + '/UploadFileServlet';

          
        }
      } catch (e) {
        // Catch errors during base64 processing
        uploadResponse.error(e);
      }
      
    });
    reader.onerror = (error) => {
        uploadResponse.error(error);
    };
    return uploadResponse.asObservable();;
  }

  fileUpload_old(file, uploadUrl?) {
    // this.authService.resetTimer();
    
    const url = this.appConfig.appBaseUrl['baseUrl'] + '/UploadFileServlet?filePath=' + encodeURI('app') + '&entityName=' + encodeURI('CheckList/Documents');
    const headers = new HttpHeaders().set('Content-Type', 'multipart/form-data');
    let formData = new FormData();
    formData.append('file', file, file.name);
    this.ngxService.start();
    let count = 0;
    return this.http.post(uploadUrl ? uploadUrl : url, formData, { headers: { 'Content-Type': 'multipart/form-data' }, reportProgress: true, observe: 'events' })
      .pipe(map((event) => {
        console.log(count++);
        this.confirmationService.confirm({
          message: "File Uploaded Successfully",
          header: 'Success',
          icon: 'fa fa-check-circle',
          acceptLabel: 'OK',
          rejectVisible: false,
        });
        this.ngxService.stop();
        return event;
      }, (err) => {
        console.log(err);
        this.ngxService.stop();
      }));
  }

  downloadFile(url: string) {
    // this.authService.resetTimer();
    // window.location.assign(url);
    var link = document.createElement('a');
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.href = url;
    link.click();
  }

  getScheduleList(requestParam: any, path: string): Observable<any> {
    // this.authService.resetTimer();
    const url = this.calendarBaseUrl + '/restcal/JourneyCalendar/' + path;
    let headers = new HttpHeaders();
    this.ngxService.start();
    headers = headers.set('Content-Type', 'application/json');
    return this.http.post(url, requestParam, { 'headers': headers })
      .pipe(map((res) => {
        this.ngxService.stop();
        if (res['strFailureMsg']) {
          this.confirmationService.confirm({
            message: res['strFailureMsg'],
            header: 'Error',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'OK',
            rejectVisible: false,
          });
          throw new Error(res['strFailureMsg']);
        } else if (res['strSuccessMsg']) {
          this.confirmationService.confirm({
            message: res['strSuccessMsg'],
            header: 'Success',
            icon: 'fa fa-check-circle',
            acceptLabel: 'OK',
            rejectVisible: false,
          });
          return res;
        }
        return res;
      }, (err) => {
        this.confirmationService.confirm({
          message: err,
          header: 'Error',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'OK',
          rejectVisible: false,
        });
        this.ngxService.stop();
        return err;
      })
      );
  }

  getLatestVehicleDetailsFromIVMS(assetIds) {
    // this.authService.resetTimer();
    const url = this.appConfig.ivmsActualsUrl + 'getLatestVehicleData';
    // const requestData = {
    //   tenantid: this.appConfig.ivmsTenantId,
    //   assetid: assetIds,
    //   enableCors: true
    // };
    const requestData={
      assetIDList: assetIds.join(","),
      enableCors: true
    }
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return this.http.post(url, requestData, { headers: { 'Content-Type': 'application/json' } });
    // return this.http.get('./assets/data/latestData.json');
  }

  getFenceDetails(requestData) {
    // this.authService.resetTimer();
    this.ngxService.start();
    const headers = new HttpHeaders().set('Content-Type', 'application/json')
      .set('Accept', '*/*')
      .set('X-Requested-With', 'XMLHttpRequest');

    // let httpParms: HttpParams = new HttpParams();
    // for (const param in requestData) {
    //   if (param && requestData.hasOwnProperty(param)) {
    //     httpParms = httpParms.set(param, requestData[param]);
    //   }
    // }
    return this.post(requestData, headers, '', this.ivmsBaseUrl);
  }

  getVehicleDetails(reqData) {
    //this.ngxService.start();
    const url = this.appConfig.ivmsActualsUrl + 'getIVMSVehicleID';
        const headers = new HttpHeaders().set('Content-Type', 'application/json')
      .set('Accept', '*/*')
      .set('X-Requested-With', 'XMLHttpRequest');
    reqData.enableCors = true;
    return this.http.post(url, reqData, { 'headers': headers });
  }

  getCarrierDriverDetails(reqData) {
    //this.ngxService.start();
    const url = this.appConfig.ivmsActualsUrl + 'getIVMSDriversFromEmpID';
        const headers = new HttpHeaders().set('Content-Type', 'application/json')
      .set('Accept', '*/*')
      .set('X-Requested-With', 'XMLHttpRequest');
    reqData.enableCors = true;
    return this.http.post(url, reqData, { 'headers': headers });
  }

  getActualsDetailsFromIVMS(requestData, url) {
    // this.authService.resetTimer();
    this.ngxService.start();
    const ivmsUrl = this.appConfig.ivmsActualsUrl + url;
    const headers = new HttpHeaders().set('Content-Type', 'application/json')
      .set('Accept', '*/*')
      .set('X-Requested-With', 'XMLHttpRequest');

    requestData.enableCors = true;
    return this.http.post(ivmsUrl, requestData, { 'headers': headers });
  }

  doUnscubscribe() {
    // this.subscribed$.unsubscribe();
  }
}
